export const name_validation = {
  name: "name",
  label: "name",
  type: "text",
  id: "name",
  placeholder: "Your name",
  multiline: false,
  className: "",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    maxLength: {
      value: 30,
      message: "30 characters max",
    },
  },
};

export const from_hidden_validation = {
  name: "form",
  label: "form",
  type: "hidden",
  id: "form",
  placeholder: "",
  className: "",
  value: "Footer Form",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

export const to_hidden_validation = {
  name: "to",
  label: "to",
  type: "hidden",
  id: "to",
  placeholder: "",
  className: "",
  value: "web@twid.marketing",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

export const company_validation = {
  name: "company",
  label: "company",
  type: "text",
  id: "company",
  placeholder: "Company",
  multiline: false,
  className: "",
  validation: {
    required: {
      value: false,
      message: "required",
    },
    maxLength: {
      value: 30,
      message: "30 characters max",
    },
  },
};

export const message_validation = {
  name: "message",
  label: "message",
  type: "textarea",
  multiline: true,
  id: "message",
  placeholder: "Message",
  className: "",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    maxLength: {
      value: 200,
      message: "200 characters max",
    },
  },
};

export const password_validation = {
  name: "password",
  label: "password",
  type: "password",
  id: "password",
  placeholder: "type password ...",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    minLength: {
      value: 6,
      message: "min 6 characters",
    },
  },
};

export const num_validation = {
  name: "num",
  label: "number",
  type: "number",
  id: "num",
  placeholder: "write a random number",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

export const email_validation = {
  name: "email",
  label: "email address",
  type: "email",
  id: "email",
  placeholder: "E-mail",
  multiline: false,
  className: "",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    pattern: {
      value:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      message: "not valid",
    },
  },
};
